import Decimal from 'decimal.js'

// Avoid exponential notation for large numbers
Decimal.set({ toExpPos: 9e15 })
